export default __webpack_public_path__ + "static/media/whatsapp-icon.0a32e23b.svg";